import { t } from 'i18next';
import { TableInstance } from 'react-table';
import { CustomerSubscriptionsTableSubscriptionFragment } from '~components/organization/CustomerSubscriptionsTable/__generated__/CustomerSubscriptionsTable.graphql';
import { PageSizeSelector } from '~components/ui/PageSizeSelector';
import { Pagination } from '~components/ui/Pagination';

export function CustomerSubscriptionsTablePagination({
  table,
}: {
  table: TableInstance<CustomerSubscriptionsTableSubscriptionFragment>;
}) {
  const {
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    gotoPage,
    state: { pageIndex },
    pageCount,
  } = table;

  return (
    <Pagination
      pageCount={pageCount}
      currentPageIndex={pageIndex}
      hasPreviousPage={canPreviousPage}
      hasNextPage={canNextPage}
      goToPage={gotoPage}
      goToPreviousPage={previousPage}
      goToNextPage={nextPage}
    />
  );
}

export function CustomerSubscriptionsTablePageSizeSelector({
  table,
  sizes,
}: {
  table: TableInstance<CustomerSubscriptionsTableSubscriptionFragment>;
  sizes?: number[];
}) {
  const {
    state: { pageSize },
    setPageSize,
  } = table;

  return (
    <PageSizeSelector
      label={t('subscriptionsPerPage')}
      onChange={setPageSize}
      options={sizes}
      value={pageSize}
    />
  );
}
